import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "HOME", testid: "nav-home" },
  { to: "/pricelist", label: "PRICELIST", testid: "nav-pricelist" },
  { to: "/terms", label: "TERMS", testid: "nav-terms" },
  { to: "/contact", label: "CONTACT", testid: "nav-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-emerald-400/10 bg-[#03100a]/70 backdrop-blur-xl">
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <NavLink to="/" data-testid="nav-logo" className="font-display text-xl font-bold tracking-widest" onClick={() => setOpen(false)}>
          <span className="text-emerald-300 text-glow-emerald">TEAM</span>
          <span className="gold-text">JAV</span>
        </NavLink>

        <div className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `font-display text-xs font-semibold tracking-[0.25em] transition-colors duration-300 ${
                  isActive ? "text-emerald-300 text-glow-emerald" : "text-emerald-100/50 hover:text-emerald-200"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="text-emerald-200 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle navigation"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-emerald-400/10 bg-[#03100a]/95 px-6 py-4 md:hidden">
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`${l.testid}-mobile`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `font-display text-sm font-semibold tracking-[0.25em] ${
                    isActive ? "text-emerald-300" : "text-emerald-100/60"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
